import { createAction } from "actions/createAction";
import { LOGIN_SET_DATA, LOGIN_ON_LOGOUT } from "const/actionTypes";
import { AnyAction } from "@reduxjs/toolkit";



export interface LoginRequest {
    username: string;
    password: string;
};

export interface LoginResponse {
    token: string | null;
    user: {
        id: number;
        username: string;
        email: string;
    } | null;
};

// export const setLoginData = createAction(LOGIN_SET_DATA);

// Initial state
const initialState: LoginResponse = {
    token: null,
    user: null
};

const handlers = {
    // [LOGIN_SET_DATA]: (state: LoginResponse, action: ReturnType<typeof setLoginData>) => ({
    //     ...state,
    //     data: action.payload
    // }),
    [LOGIN_ON_LOGOUT]: (state: LoginResponse, action?: AnyAction) => ({
        ...state,
        token: null,
        user: null
    }),
    DEFAULT: (state: LoginResponse) => state
} as const;

// Reducer
const loginReducer = (state = initialState, action: AnyAction) => {
    const handle = handlers[action.type as keyof typeof handlers] || handlers.DEFAULT;
    return handle(state, action as any);
};

export default loginReducer; 